var React = require('react');

function GistMap (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"gist_map"),React.createElement("g",{"key":1},[React.createElement("circle",{"cx":"24","cy":"14","r":"2","key":0}),React.createElement("circle",{"cx":"24","cy":"24.04","r":"2","key":1}),React.createElement("circle",{"cx":"24","cy":"34","r":"2","key":2}),React.createElement("circle",{"cx":"32","cy":"19","r":"2","key":3}),React.createElement("circle",{"cx":"16","cy":"19","r":"2","key":4}),React.createElement("circle",{"cx":"32","cy":"29","r":"2","key":5}),React.createElement("circle",{"cx":"16","cy":"29","r":"2","key":6})])]);
}

GistMap.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = GistMap;

GistMap.default = GistMap;
